var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDeviceLoaded)?_c('div',[_c('div',{staticClass:"columns is-mobile optionsContainer"},[_c('div',{staticClass:"column",class:_vm.getDeviceTemperatureColorBackground(_vm.device, _vm.schedule),staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.$router.push(
          '/installations/' +
            _vm.installation['.key'] +
            '/zone/' +
            _vm.zone.path.split('/')[_vm.zone.path.split('/').length - 1] +
            '/device/' +
            _vm.device.serialnumber +
            '/edit'
        )}}},[_vm._m(0)]),_c('div',{staticClass:"column",class:_vm.getDeviceTemperatureColorBackground(_vm.device, _vm.schedule),staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.$router.push(
          '/installations/' +
            _vm.installation['.key'] +
            '/zone/' +
            _vm.zone.path.split('/')[_vm.zone.path.split('/').length - 1] +
            '/device/' +
            _vm.device.serialnumber +
            '/info'
        )}}},[_vm._m(1)]),(!_vm.isFloor)?_c('div',{staticClass:"column",class:_vm.getDeviceTemperatureColorBackground(_vm.device, _vm.schedule),staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.$router.push(
          '/installations/' +
            _vm.installation['.key'] +
            '/zone/' +
            _vm.zone.path.split('/')[_vm.zone.path.split('/').length - 1] +
            '/device/' +
            _vm.device.serialnumber +
            '/settings'
        )}}},[_c('img',{attrs:{"src":"/home/images/zones/btn_ajustes.png"}})]):_vm._e()]),_c('device-thermostat',{class:_vm.getDeviceTemperatureColorBackground(_vm.device, _vm.schedule),attrs:{"id":"thermostat","schedule":_vm.schedule}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon clickable"},[_c('i',{staticClass:"mdi mdi-pencil"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon clickable"},[_c('i',{staticClass:"mdi mdi-information-outline"})])}]

export { render, staticRenderFns }